import React from 'react';
import imageLoading from '../../helpers/lottie-files/imageLoader.json';
import LottieAnimation from '../LottieAnimation';

function Spinner(props) {
    const { width, height } = props;
    return(
        <LottieAnimation loop={true} animateFile={imageLoading} height={height || 70} width={width || 70} />
    )
}
export default Spinner;